import React from "react";

// Rio Code logo mark - matches the provided logo (blue rounded square with </> code icon)
export const LogoMark = ({ size = 32, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Rio Code logo mark"
  >
    <rect width="64" height="64" rx="12" fill="#2648FF" />
    {/* Left bracket < */}
    <path
      d="M22 16 L10 32 L22 48"
      stroke="#FFFFFF"
      strokeWidth="3"
      strokeLinecap="square"
      strokeLinejoin="miter"
      fill="none"
    />
    {/* Right bracket > */}
    <path
      d="M42 16 L54 32 L42 48"
      stroke="#FFFFFF"
      strokeWidth="3"
      strokeLinecap="square"
      strokeLinejoin="miter"
      fill="none"
    />
    {/* Middle wave (river) */}
    <path
      d="M22 34 Q27 26 32 30 Q37 34 42 30"
      stroke="#FFFFFF"
      strokeWidth="2.5"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

export const LogoLockup = ({ size = 28, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <LogoMark size={size} />
    <span className="font-display font-semibold tracking-tight text-white text-lg">
      <span className="text-brand">rio</span>
      <span className="text-white">-code</span>
    </span>
  </div>
);
